import { Chip } from "@mui/material";
import React from "react";

import "./styles.scss";

const Tag = ({ name, color }) => (
    <Chip
        icon={<div className="icon-color-preview" style={{ backgroundColor: color }} />}
        variant="outlined"
        size="small"
        label={name || "Name"}
        color="default"
        style={{ color: color, borderColor: color }}
    />
);

export default Tag;
